module.exports = __webpack_public_path__ + "static/nova-wallet-12df7439a7fccffed5401dfcdd5d05f0.webp";